import { Injectable, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../../common/services/api.service';
import API from '../../common/services/api.config.json';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EditEmployeeModel } from 'app/modules/employee-view/entities/EditEmployeeModel';
import { map } from 'rxjs/operators';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { RestResponse as GenericRestResponse } from 'app/modules/common/entities/rest.response-generic.model';
import { EmployeeCreateModel } from '../entities/create-new-employee';
import { UntypedFormGroup } from '@angular/forms';
import { EmloyeeAvailableCheckProps } from 'app/modules/common/types/employee/emloyee-available-check-props.type';
import { Trabajador } from 'app/modules/common/types/employee/trabajador.type';

@Injectable({providedIn:'root'})
export class EmployeeService {
    @Output() EmployeeId: EventEmitter<any> = new EventEmitter<any>();
    @Output() subTrabajador: EventEmitter<any> = new EventEmitter<any>();
    @Output() selectUserData: EventEmitter<any> = new EventEmitter<any>();
    @Output() selectUserBajas: EventEmitter<any> = new EventEmitter<any>();
    @Output() selectUserappointment: EventEmitter<any> =
        new EventEmitter<any>();
    public editEmployeeData = new BehaviorSubject(null);
    @Output() provinceData: EventEmitter<any> = new EventEmitter<any>();
    @Output() provinceData1: EventEmitter<any> = new EventEmitter<any>();
    @Output() saveemplooye: EventEmitter<any> = new EventEmitter<any>();
    @Output() fromclosed: EventEmitter<any> = new EventEmitter<any>();

    /**
     * this will be set to true in case employee is deleted. This is supposed to use in UI directly
     */
    public isEmployeeDeleted = false;

    public currentEmployeeId = 0;
    public currentEmployee: any = '';
    public nevil = [];
    public bajas: any = [];
    subscription: any;
    isEmployeeLocked = false;
    public isShowPanel=false;

    public EmployeeWarningText: string;
    public HasWarningCreationPermit: boolean;
    public trabadoreColumns: any[];
    
    constructor(
        public apiService: ApiService,
        public router: Router,
        public sharedService: SharedService
    ) {}

    GetTrabajador(employeeId: number): Observable<RestResponse> {
        let url = `${API.Trabajador.Get}`;
        url = url.replace('{id}', employeeId.toString());
        return this.apiService.get(url);
    }

    getEmployeeDetails(employeeId: any): Observable<RestResponse> {
        let url = `${API.Leave.getBajaDataByEmppId}`;
        url = url.replace('{EmployeeId}', employeeId.toString());
        return this.apiService.get(url);
    }

    getheaderDetails(employeeId: any): Observable<any> {
        return this.getEmployeeDetailsForHeader(employeeId).pipe(
            map((res) => {
                this.nevil = res.result;
                this.sharedService.setNevil(res.result);
                this.sharedService.EmployeeCompany = this.nevil[0].nivel1;
                localStorage.setItem(
                    'EmplooyeeData',
                    JSON.stringify(res.result[0])
                );
            })
        );
    }

    getEmployeeDetailsForHeader(employeeId: string): Observable<RestResponse> {
        let url = `${API.Trabajador.trabajadorDetailsForHeader}`;
        url = url.replace('{trabajadorId}', employeeId);
        return this.apiService.get(url);
    }

    GetTrabDetail(employeeId: number): Observable<RestResponse> {
        let url = `${API.Trabajador.getTrabajador}`;
        url = url.replace('{trabajadorId}', employeeId.toString());
        return this.apiService.get(url);
    }

    GetEmployeeForCreateVisit(employeeId: number): Observable<RestResponse> {
        const url = `${API.Trabajador.getEmployeeForCreateVisit}`;
        return this.apiService.get(
            url.replace('{trabajadorId}', employeeId.toString())
        );
    }

    getTrabajador(employeeId: any): void {
        this.GetTrabDetail(employeeId).subscribe((res) => {
            let trabajador = {};
            trabajador = res.result;
            this.subTrabajador.emit(trabajador);
        });
    }

    getPoblacion(provinceName: string): void {
        this.apiService
            .get(API.Poblacion.getPoblacionByProvince + provinceName)
            .subscribe((res) => {
                this.provinceData.emit(res.result);
            });
    }

    getPoblacion1(provinceName: string): void {
        this.apiService
            .get(API.Poblacion.getPoblacionByProvince + provinceName)
            .subscribe((res) => {
                this.provinceData1.emit(res.result);
            });
    }

    updateEmplooye(
        EmployeeId: string,
        emplooy: EditEmployeeModel,
        masterForm: UntypedFormGroup
    ): Observable<RestResponse> {
        let empEditModel = this.TransformToSaveModel(emplooy, masterForm);

        //updateEmplooye(EmployeeId: string, emplooy: EditEmployeeModel): Observable<RestResponse> {

        let url = `${API.Trabajador.updateTrabajador}`;
        url = url.replace('{trabajadorId}', EmployeeId);

        return this.apiService.put(url, empEditModel);

        //return this.apiService.put(url, emplooy);
    }

    getemployeeID(id: any): void {
        localStorage.setItem('EmplooyeeID', id);
        this.EmployeeId.emit(id);
        this.isLockedEmployee(id);
    }

    userSelected(data: any): void {
        this.selectUserData.emit(data);
    }

    userSelectedBajas(id): void {
        this.selectUserBajas.emit(id);
    }

    userSelectedappointment(data: any): void {
        this.selectUserappointment.emit(data);
    }

    fromClosed(): void {
        this.fromclosed.emit();
    }

    publishEditEmployee(employeeData): void {
        this.editEmployeeData.next(employeeData);
    }

    subcribeEditEmployee(): BehaviorSubject<any> {
        return this.editEmployeeData;
    }
    TransformToSaveModel(
        formGroupObj: any,
        masterForm: UntypedFormGroup
    ): EditEmployeeModel {
        let newEmployee = new EditEmployeeModel();
        //let attributesFormGroup = masterForm.value.get('Attributes') as FormGroup;
        let attributesFormGroup = masterForm.value.Attributes as UntypedFormGroup;

        let attributeValues = attributesFormGroup;

        //Main details
        newEmployee.FAntiguedad = formGroupObj.FAntiguedad;
        newEmployee.FFinContrato = formGroupObj.FFinContrato;
        newEmployee.BirthDate = formGroupObj.BirthDate;
        newEmployee.Position =
            formGroupObj.Position == '' ? null : formGroupObj.Position;
        newEmployee.Telephone1 = formGroupObj.Telephone1;
        newEmployee.Telephone2 = formGroupObj.Telephone2;
        newEmployee.Movil = formGroupObj.Movil;
        newEmployee.Telephone4 = formGroupObj.Telephone4;
        newEmployee.Direction1 = formGroupObj.Direction1;
        newEmployee.Province1 = formGroupObj.Province1;
        newEmployee.City1 = formGroupObj.City1;
        newEmployee.PostalCode1 = formGroupObj.PostalCode1;
        newEmployee.Direction2 = formGroupObj.Direction2;
        newEmployee.Province2 = formGroupObj.Province2;
        newEmployee.City2 = formGroupObj.City2;
        newEmployee.PostalCode2 = formGroupObj.PostalCode2;
        newEmployee.Observation = formGroupObj.Observation;
        newEmployee.ObsDireccion = formGroupObj.ObsDireccion;
        newEmployee.Nif = formGroupObj.Nif;
        newEmployee.Sexo = formGroupObj.Sexo;
        newEmployee.Apellidos = formGroupObj.Apellidos;
        newEmployee.Nombre = formGroupObj.Nombre;
        newEmployee.RefTrabajador = formGroupObj.RefTrabajador;
        newEmployee.TipoConsentimiento = formGroupObj.TipoConsentimiento;
        newEmployee.Consentimiento = formGroupObj.Consentimiento;
        newEmployee.PuestoUrgente = formGroupObj.PuestoUrgente;
        newEmployee.TelCancelado = formGroupObj.TelCancelado;

        // Fill up employee attributes
        for (let attributeIndex = 1; attributeIndex <= 13; attributeIndex++) {
            // get attribute name
            const attributeName = `Atributo${attributeIndex}`;

            // get attribute contrp;
            const attribute = attributeValues[attributeName];

            // set employee attribute
            newEmployee[attributeName] =
                !attribute || attribute == '' ? null : attribute;
        }

        return newEmployee;
    }

    public GetFullName(res): string {
        let lastname: string = res.apellidos;
        let firstname: string = res.nombre;
        let fullname: string;
        if (lastname && lastname !== null && lastname.trim() !== '') {
            lastname = lastname.trim();
        }

        if (firstname && firstname !== null && firstname.trim() !== '') {
            firstname = firstname.trim();
        }

        fullname = lastname;
        if (fullname && firstname) {
            fullname = `${fullname} , ${firstname}`;
        }
        return fullname;
    }

    public CheckIsLockedEmployee(empId: any): Observable<RestResponse> {
        let url = `${API.Trabajador.checkIsLockedEmployee}`;
        url = url.replace('{trabajadorId}', empId);
        return this.apiService.get(url);
    }

    public isLockedEmployee(empId): void {
        this.isEmployeeLocked = false;
        this.CheckIsLockedEmployee(empId).subscribe((res) => {
            if (res) {
                this.isEmployeeLocked = res.result;
            }
        });
    }

    // NEW ACTIONS FOR SELCTION RESULTS -- NEEDS TO BE UPDATED TO PROPER API CALL
    public DeleteEmployee(empId): any {
        let url = `${API.Trabajador.deleteEmployee}`;
        url = url.replace('{trabajadorId}', empId);
        return this.apiService.delete(url);
    }

    public UnlockEmployee(empId): any {
        let url = `${API.Trabajador.unlockEmployee}`;
        url = url.replace('{trabajadorId}', empId);
        return this.apiService.put(url);
    }

    public TraspasarEmployee(companyId, selectionParametes): any {
        let url = `${API.Selection.transferEmployee}`;
        url = url.replace('{empressaId}', companyId);
        return this.apiService.put(url, selectionParametes);
    }

    public InitEmployeeWarning(EmployeeId: any, leaveId : any): void {
        this.isShowPanel=false;
        this.HasWarningCreationPermit = this.sharedService
            .getCurrentUserPermissions()
            .includes('306');
        this.GetEmployeeWarningText(EmployeeId, leaveId).subscribe(
            (res) => {
                if (res.code === 0) {
                    this.EmployeeWarningText = res.result;
                    this.isShowPanel=true;
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }

    public GetEmployeeWarningText(employeeId: any, leaveId : any): Observable<RestResponse> {
        let url = `${API.Trabajador.getWarningText}`;
        url = url.replace('{employeeId}', employeeId);
        url = url.replace('{leaveId}', leaveId);
        return this.apiService.get(url);
    }

    public SaveWarningText(
        employeeId: string,
        warningData: any
    ): Observable<RestResponse> {
        let url = `${API.Trabajador.saveWarningText}`;
        url = url.replace('{employeeId}', employeeId);
        return this.apiService.put(url, warningData);
    }

    public DeleteEmployeeWarningText(
        employeeId: any
    ): Observable<RestResponse> {
        let url = `${API.Trabajador.deleteWarningText}`;
        url = url.replace('{employeeId}', employeeId);
        return this.apiService.delete(url);
    }

    /**
     * Check if any employee is available for the given company and other optional properties
     */
    public isEmployeeAvailable(
        props: EmloyeeAvailableCheckProps
    ): Observable<GenericRestResponse<Trabajador>> {
        let url = API.Trabajador.isEmployeeAvailable as string;
        return this.apiService.post(url, props);
    }

    /**
     * Check if any employee is available for the given company and other optional properties
     */
    public unblockEmployee(id: number): Observable<GenericRestResponse<null>> {
        let url = (API.Trabajador.unblock as string).replace(
            '{id}',
            id.toString()
        );
        return this.apiService.post(url);
    }

    //#region "Create new employee"

    public createNewEmployee(
        newEmployee: EmployeeCreateModel
    ): Observable<RestResponse> {
        let url = `${API.Trabajador.createNewEmployee}`;
        return this.apiService.post(url, newEmployee);
    }

    public isEmployeeNIFAvailable(
        companyId: number,
        employeeNIF: string
    ): Observable<RestResponse> {
        let url = `${API.Trabajador.isEmployeeNIFAvailable}`;
        url = url.replace(
            '{companyId}',
            companyId == null ? '0' : companyId.toString()
        );
        url = url.replace('{employeeNIF}', employeeNIF);
        return this.apiService.get(url);
    }

    //#endregion

    //#region "Employee Options"

    /**
     * Move an employee to a company
     * @param moveLeaves If true, leaves this employee will also be moved to new company
     */
    public moveEmployee(
        employeeId: number,
        companyId: number,
        moveLeaves: boolean
    ): Observable<RestResponse> {
        const url = (API.Trabajador.moveEmployee as string)
            .replace('{employeeId}', employeeId.toString())
            .replace('{companyId}', companyId.toString())
            .replace('{moveLeaves}', moveLeaves.toString());

        return this.apiService.post(url);
    }

    /**
     * Locks the given employee
     */
    public locksEmployee(employeeId: number): Observable<RestResponse> {
        const url = (API.Trabajador.lockEmployee as string).replace(
            '{employeeId}',
            employeeId.toString()
        );

        return this.apiService.post(url);
    }

    /**
     * Cancel employee data
     */
    public cancelEmployeeData(
        employeeId: number,
        companyId: number
    ): Observable<RestResponse> {
        const url = (API.Trabajador.cancelEmployeeData as string)
            .replace('{employeeId}', employeeId.toString())
            .replace('{companyId}', companyId.toString());

        return this.apiService.post(url);
    }

    /**
     * Delete employee
     */
    public deleteEmployee(
        employeeId: number,
        motivo: string
    ): Observable<RestResponse> {
        const url = (API.Trabajador.deleteEmployeeWithMotivo as string)
            .replace('{employeeId}', employeeId.toString())
            .replace('{motivo}', motivo);

        return this.apiService.delete(url);
    }

    //#endregion
}
